<template>
  <div :class="['HomeSlides', { tinitial: first }, transition]" ref="container">
    <!-- Use the following v-for during debug to see all slides -->
    <!-- <HomeSlide v-for="slide in entries" :slide="slide"></HomeSlide> -->
    <HomeSlide v-if="slide" :slide="slide"></HomeSlide>
  </div>
</template>

<script>
import createCycle from "lei-cycle";

import HomeSlide from "./HomeSlide";

export default {
  name: "HomeSlides",
  components: { HomeSlide },
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      transitions: createCycle(["tbottom", "tleft", "ttop", "tright"]),
      transition: "",
      slides: createCycle(this.entries),
      slide: "",
      frame: {},
      first: true,
    };
  },
  mounted() {
    // for debug, render all slide layouts in v-for
    // for production, render this.slide

    this.slide = this.slides();
    this.frame.slides = setTimeout(this.transitionOut.bind(this), 6000);
  },
  willDestroy() {
    clearInterval(this.frame.slides);
  },
  methods: {
    transitionIn() {
      this.slide = this.slides();
      this.transition = "";
      this.frame.slides = setTimeout(() => this.transitionOut(), 6000);
    },
    transitionOut() {
      this.first = false;
      this.transition = this.transitions();
      this.frame.slides = setTimeout(() => this.transitionIn(), 1000);
    },
  },
};
</script>

<style scoped>
.HomeSlides {
  clip-path: inset(0 0 0 0);
  -webkit-clip-path: inset(0 0 0 0);
  transition: clip-path 1500ms linear, -webkit-clip-path 1500ms linear;
  padding-bottom: calc(var(--mb) + 2.5rem);

  height: 100%;
  padding-bottom: 4.5rem;
}

.ttop {
  clip-path: inset(100% 0 0 0);
  -webkit-clip-path: inset(100% 0 0 0);
}

.tleft {
  clip-path: inset(0 100% 0 0);
  -webkit-clip-path: inset(0 100% 0 0);
}

.tbottom {
  clip-path: inset(0 0 100% 0);
  -webkit-clip-path: inset(0 0 100% 0);
}

.tright {
  clip-path: inset(0 0 0 100%);
  -webkit-clip-path: inset(0 0 0 100%);
}

.tinitial {
  animation: transition-in 1000ms linear;
}

@keyframes transition-in {
  from {
    clip-path: inset(0 0 100% 0);
    -webkit-clip-path: inset(0 0 100% 0);
  }
  to {
    clip-path: inset(0 0 0 0);
    -webkit-clip-path: inset(0 0 0 0);
  }
}

/*@media (max-width: 920px) {
  .container {
    max-height: calc(100vh - 28rem);
  }
}*/
</style>
